export default __webpack_public_path__ + "static/1. Student Management Made Easy 2-267c659b8615ce5e6893a3ca4ab1d671.jpg";